'use client';

import { useCallback, useState } from 'react';
import Alert from '@/components/shared/Alert';
import { CSN_SEARCH_BANNER_COOKIE_NAME } from '@/constants/cookieConstants';

export type LoginBannerProps = {
  loginBannerMessage: string;
  loginBannerMessageAriaLabel: string;
  loginBannerCloseAriaLabel: string;
};

type Props = {
  loginBannerContent: LoginBannerProps;
};

export default function LoginBanner({ loginBannerContent }: Props): JSX.Element {
  const { loginBannerMessage, loginBannerCloseAriaLabel } = loginBannerContent;
  const [showLoginBanner, setShowLoginBanner] = useState(true);
  const onLoginBannerClose = useCallback(() => {
    setShowLoginBanner(false);

    // update cookie
    if (typeof document !== 'undefined') {
      document.cookie = `${CSN_SEARCH_BANNER_COOKIE_NAME}=${JSON.stringify({
        isLoginBannerDismissed: true,
        dismissedRfpBannerId: ''
      })}`;
    }
  }, []);

  return (
    <>
      {showLoginBanner && (
        <Alert
          appearance="info"
          content={loginBannerMessage}
          isDismissable
          dismissAriaLabel={loginBannerCloseAriaLabel}
          onClose={onLoginBannerClose}
          testID="login-banner"
        />
      )}
    </>
  );
}
